module.exports = __webpack_public_path__ + "assets/img/kanala-icon.22283a7c.png";